class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    // 05/09/2026 : une seule reference liee, gardee sur l'instance. Avec this.close.bind(this)
    // ecrit a chaque appel, renderContents() ajoutait un ecouteur de plus a chaque mise a
    // jour du panier, sans jamais retirer le precedent.
    this.onOverlayClick = this.close.bind(this);
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.onOverlayClick);
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  // 05/09/2026 — le guide des tailles est un modal a part (z-index 99999, voile
  // rgba(43,39,36,.45)). Il passait au-dessus du panier et survivait a sa fermeture :
  // le client fermait le panier et gardait un voile gris sur toute la boutique.
  // On ferme donc le guide avant d'ouvrir le panier : un seul panneau a la fois.
  fermeGuideDesTailles() {
    const guide = document.getElementById('cpx-sg-overlay');
    if (guide && guide.classList.contains('is-open')) {
      guide.classList.remove('is-open');
      document.body.classList.remove('cpx-sg-lock');
    }
  }

  open(triggeredBy) {
    this.fermeGuideDesTailles();
    if (triggeredBy) this.setActiveElement(triggeredBy);
    // CP 02/08 : garde anti-course. Une fermeture arrivee entre open() et son
    // setTimeout laissait le timer en retard rouvrir le voile sur une page fermee.
    this.isOpen = true;
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      if (!this.isOpen) return; // CP : une fermeture est passee entre-temps
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.isOpen = false; // CP : neutralise tout timer d'ouverture en attente
    // BS-FERMETURE-PROPRE 27/08/2026 : on horodate la fermeture. renderContents()
    // se termine par un open() INCONDITIONNEL ; quand un rafraichissement du
    // panier tombait juste apres une fermeture, le tiroir se rouvrait et laissait
    // un voile gris sur la page. L'horodatage permet de distinguer ce cas d'un
    // vrai ajout au panier, qui doit continuer d'ouvrir le tiroir.
    this.closedAt = Date.now();
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    // 'animate' restait posee apres la fermeture : sur certains navigateurs le
    // voile continuait d'etre peint. On la retire une fois l'animation finie.
    clearTimeout(this._bsPurge);
    this._bsPurge = setTimeout(() => {
      if (!this.isOpen) this.classList.remove('animate');
    }, 500);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      // CP : garde null. Cette ligne levait "Cannot read properties of null" en production.
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        overlay.removeEventListener('click', this.onOverlayClick);
        overlay.addEventListener('click', this.onOverlayClick);
      }
      // BS-FERMETURE-PROPRE : ne pas rouvrir si l'utilisateur vient de fermer.
      // Un ajout au panier n'est jamais precede d'une fermeture immediate, il
      // ouvre donc toujours normalement.
      if (this.closedAt && Date.now() - this.closedAt < 700) return;
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
